<template>
  <div style="margin-top: 20px">
    <vue-toastr ref="toast"></vue-toastr>

    <div v-if="loading" class="text-center p-4">
      <i class="fa fa-spinner fa-spin fa-2x"></i>
    </div>

    <div v-else>
      <!-- Variants Tabs -->
      <ul class="nav nav-tabs" v-if="variants.length > 0">
        <li v-for="variant in variants" :key="variant.id" :class="{ active: activeVariant === variant.id }">
          <a href="#" @click.prevent="selectVariant(variant.id)">
            Variante {{ variant.variant_number }}
          </a>
        </li>
        <li v-if="variants.length < maxVariants">
          <a href="#" @click.prevent="addVariant" class="text-success">
            <i class="fa fa-plus"></i> Neue Variante
          </a>
        </li>
      </ul>

      <!-- No variants message -->
      <div v-if="variants.length === 0" class="alert alert-info">
        <p>Keine Varianten vorhanden.</p>
        <button class="btn btn-primary" @click="addVariant">
          <i class="fa fa-plus"></i> Erste Variante erstellen
        </button>
      </div>

      <!-- Variant Content -->
      <div v-for="variant in variants" :key="variant.id" v-show="activeVariant === variant.id" class="tab-content p-3">
        <div class="ibox box-primary">
          <div class="ibox-title with-border">
            <h3 class="box-title">Punktesystem-Simulation - Variante {{ variant.variant_number }}</h3>
            <div class="box-tools pull-right" v-if="variant.variant_number > 1">
              <button class="btn btn-danger btn-sm" @click="deleteVariant(variant)" :disabled="saving">
                <i class="fa fa-trash"></i> Variante löschen
              </button>
            </div>
          </div>
          <div style="margin-top: 10px">
            <!-- Umrechnung des Punktesystems -->
            <div class="ibox box-default">
              <div class="ibox-title with-border">
                <h4 class="box-title">
                  Umrechnung des Punktesystems
                  <small class="text-danger">(Pflichtfeld)</small>
                </h4>
              </div>
              <div class="ibox-content">
                <!-- Punkte sammeln Panel -->
                <div class="row">
                  <div class="col-md-6">
                    <div class="panel panel-default">
                      <div class="panel-heading" style="background-color: #f5f5f5;">
                        Punkte sammeln
                      </div>
                      <div class="panel-body">
                        <div class="row">
                          <div class="col-md-3">
                            <label>Betrag in Euro</label>
                            <input type="number" v-model.number="variant.earn_from_amount" class="form-control"
                                   step="0.01" min="0">
                          </div>
                          <div
                              class="col-md-6 d-flex align-items-center justify-content-center text-center text-nowrap">
                            <label>&nbsp;</label>
                            <h4>
                              <i class="fa fa-eur" aria-hidden="true"></i>
                              &nbsp;&nbsp;
                              <i class="fa fa-arrow-right" aria-hidden="true"></i>
                              &nbsp;&nbsp;
                              wird umgerechnet in
                              &nbsp;&nbsp;
                              <i class="fa fa-arrow-right" aria-hidden="true"></i>
                              &nbsp;&nbsp;
                              <i class="fa fa-trophy" aria-hidden="true"></i>
                            </h4>
                          </div>
                          <div class="col-md-3">
                            <label>Anzahl der Punkte</label>
                            <input type="number" v-model.number="variant.earn_to_points" class="form-control" min="0">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Punkte einlösen Panel -->
                <div class="row">
                  <div class="col-md-6">
                    <div class="panel panel-default">
                      <div class="panel-heading" style="background-color: #f5f5f5;">
                        Punkte einlösen
                      </div>
                      <div class="panel-body">
                        <div class="row">
                          <div class="col-md-3">
                            <label>Anzahl der Punkte</label>
                            <input type="number" v-model.number="variant.redeem_from_points" class="form-control"
                                   min="0">
                          </div>
                          <div
                              class="col-md-6 d-flex align-items-center justify-content-center text-center text-nowrap">
                            <label>&nbsp;</label>
                            <h4>
                              <i class="fa fa-trophy" aria-hidden="true"></i>
                              &nbsp;&nbsp;
                              <i class="fa fa-arrow-right" aria-hidden="true"></i>
                              &nbsp;&nbsp;
                              wird umgerechnet in
                              &nbsp;&nbsp;
                              <i class="fa fa-arrow-right" aria-hidden="true"></i>
                              &nbsp;&nbsp;
                              <i class="fa fa-eur" aria-hidden="true"></i>
                            </h4>
                          </div>
                          <div class="col-md-3">
                            <label>Betrag in Euro</label>
                            <div class="input-group">
                              <input type="number" v-model.number="variant.redeem_to_amount" class="form-control"
                                     step="0.01" min="0">
                              <span class="input-group-addon">&euro;</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Zeitraum für die Berechnung -->
            <div class="ibox box-default">
              <div class="ibox-title with-border">
                <h4 class="box-title">
                  Zeitraum für die Berechnung
                  <small class="text-danger">(Pflichtfeld)</small>
                </h4>
              </div>
              <div class="ibox-content">
                <div class="row">
                  <div class="col-md-3">
                    <label>Startdatum</label>
                    <input type="date" v-model="variant.calculation_start_date" class="form-control">
                  </div>
                  <div class="col-md-3">
                    <label>Enddatum</label>
                    <input type="date" v-model="variant.calculation_end_date" class="form-control">
                  </div>
                </div>
              </div>
            </div>

            <!-- Einlösequote -->
            <div class="ibox box-default">
              <div class="ibox-title with-border">
                <h4 class="box-title">
                  Angenommene Einlösequote
                  <small class="text-danger">(Pflichtfeld)</small>
                </h4>
              </div>
              <div class="ibox-content">
                <div class="row">
                  <div class="col-md-3">
                    <div class="input-group">
                      <input type="number" v-model.number="variant.redemption_rate" class="form-control" step="0.01"
                             min="0" max="100">
                      <span class="input-group-addon">%</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Ausschlüsse -->
            <div class="ibox box-default">
              <div class="ibox-title with-border">
                <h4 class="box-title">Ausschlüsse</h4>
                <div class="box-tools pull-right" v-if="variant.variant_number > 1">
                  <button class="btn btn-default btn-sm" @click="copyExclusionsFromPreviousVariant(variant)"
                          :disabled="saving">
                    <i class="fa fa-copy"></i> Von Variante {{ variant.variant_number - 1 }} übernehmen
                  </button>
                </div>
              </div>
              <div class="ibox-content">
                <!-- Product exclusions -->
                <h5>Ausschlüsse nach Warengruppen</h5>
                <simulation-exclusions-product
                    :ref="'exclusionsProduct_' + variant.id"
                    :variant-id="variant.id"
                    :initial-items="variant.exclusion_products || []"
                    :product-groups="productGroups"
                ></simulation-exclusions-product>

                <!-- Customer exclusions -->
                <h5 class="mt-4">Ausschlüsse nach Kundennummern</h5>
                <simulation-exclusions-customer
                    :ref="'exclusionsCustomer_' + variant.id"
                    :variant-id="variant.id"
                    :initial-items="variant.exclusion_customers || []"
                ></simulation-exclusions-customer>
              </div>
            </div>

            <!-- Ausschluss von Reduzierungen -->
            <div class="ibox box-default">
              <div class="ibox-title with-border">
                <h4 class="box-title">Ausschluss von Reduzierungen</h4>
              </div>
              <div class="ibox-content">
                <div class="form-group">
                  <label style="cursor: pointer; font-weight: normal;">
                    <input type="checkbox"
                           class="i-checks"
                           v-model="variant.exclude_discounted_items"
                           style="margin-right: 8px;">
                    Reduzierte Artikel in der Berechnung ausschließen
                  </label>
                </div>
              </div>
            </div>

            <!-- Ausschluss von Laufkunden -->
            <div class="ibox box-default">
              <div class="ibox-title with-border">
                <h4 class="box-title">Ausschluss von Laufkunden</h4>
              </div>
              <div class="ibox-content">
                <div class="form-group">
                  <label style="cursor: pointer; font-weight: normal;">
                    <input type="checkbox"
                           class="i-checks"
                           v-model="variant.exclude_walk_in_customers"
                           style="margin-right: 8px;">
                    Laufkunden in der Berechnung ausschließen
                  </label>
                </div>
              </div>
            </div>

            <!-- Statusstufen -->
            <div class="ibox box-default">
              <div class="ibox-title with-border">
                <h4 class="box-title">Statusstufen mit Punkteausschüttung</h4>
              </div>
              <div class="ibox-content">
                <p class="text-muted small">
                  Wenn die Felder leer bleiben, werden keine Statusstufen in die Berechnung miteinbezogen.
                </p>
                <simulation-status-levels
                    :ref="'statusLevels_' + variant.id"
                    :variant-id="variant.id"
                    :initial-items="variant.status_levels || []"
                ></simulation-status-levels>
              </div>
            </div>

          </div>
        </div>
      </div>

      <!-- Global Action Buttons -->
      <div class="text-right mt-3" v-if="variants.length > 0">
        <button class="btn btn-success" @click="saveAll" :disabled="saving">
          Speichern
        </button>
        <button class="btn btn-primary" @click="startCalculation" :disabled="saving" style="margin-left: 10px;">
          Berechnung starten
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import VueToastr from "vue-toastr";
import axios from "axios";
import SimulationExclusionsProduct from "./SimulationExclusionsProduct.vue";
import SimulationExclusionsCustomer from "./SimulationExclusionsCustomer.vue";
import SimulationStatusLevels from "./SimulationStatusLevels.vue";

export default {
  name: "SimulationVariantEditor",
  components: {
    VueToastr,
    SimulationExclusionsProduct,
    SimulationExclusionsCustomer,
    SimulationStatusLevels,
  },
  props: {
    simulationId: {
      type: [String, Number],
      required: true,
    },
    clientId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      variants: [],
      activeVariant: null,
      loading: true,
      saving: false,
      maxVariants: 3,
      productGroups: {},
    };
  },
  computed: {},
  mounted() {
    this.fetchVariants();
  },
  methods: {
    formatNumber(value) {
      if (value === null || value === undefined) return '-';
      return new Intl.NumberFormat('de-DE').format(value);
    },
    formatCurrency(value) {
      if (value === null || value === undefined) return '-';
      return new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
      }).format(value);
    },
    getStatusLevelsWithResults(variant) {
      if (!variant.status_levels || variant.status_levels.length === 0) {
        return [];
      }
      return variant.status_levels
        .filter(level => level.customers_reached !== null)
        .sort((a, b) => a.level_number - b.level_number);
    },
    async fetchVariants() {
      try {
        const response = await axios.get(`/backend/loyalty-program/point-system-simulations/${this.simulationId}/variants`);
        this.variants = response.data.variants;
        this.productGroups = response.data.productGroups || {};
        if (this.variants.length > 0) {
          this.activeVariant = this.variants[0].id;
        }
      } catch (error) {
        this.$refs.toast.e("Fehler beim Laden der Varianten.", "Fehler");
      } finally {
        this.loading = false;
      }
    },
    selectVariant(variantId) {
      this.activeVariant = variantId;
    },
    addVariant() {
      if (this.variants.length >= this.maxVariants) {
        this.$refs.toast.w("Maximal 3 Varianten möglich.", "Warnung");
        return;
      }

      const nextVariantNumber = this.variants.length + 1;
      const tempId = 'new-' + Date.now();

      // Create variant locally (will be saved to DB on save)
      const newVariant = {
        id: tempId,
        variant_number: nextVariantNumber,
        earn_from_amount: 0,
        earn_to_points: 0,
        redeem_from_points: 0,
        redeem_to_amount: 0,
        exclude_discounted_items: false,
        exclude_walk_in_customers: true,
        calculation_start_date: null,
        calculation_end_date: null,
        redemption_rate: null,
        exclusion_products: [],
        exclusion_customers: [],
        status_levels: [],
        _isNew: true,
      };

      this.variants.push(newVariant);
      this.activeVariant = tempId;
    },
    async saveVariant(variant) {
      const payload = {
        earn_from_amount: variant.earn_from_amount,
        earn_to_points: variant.earn_to_points,
        redeem_from_points: variant.redeem_from_points,
        redeem_to_amount: variant.redeem_to_amount,
        exclude_discounted_items: variant.exclude_discounted_items,
        exclude_walk_in_customers: variant.exclude_walk_in_customers,
        calculation_start_date: variant.calculation_start_date,
        calculation_end_date: variant.calculation_end_date,
        redemption_rate: variant.redemption_rate,
        exclusion_products: this.getExclusionProducts(variant.id),
        exclusion_customers: this.getExclusionCustomers(variant.id),
        status_levels: this.getStatusLevels(variant.id),
      };

      let response;
      const oldId = variant.id;

      if (variant._isNew) {
        // Create new variant
        response = await axios.post(
          `/backend/loyalty-program/point-system-simulations/${this.simulationId}/variants`,
          payload
        );

        // Update variant with server data (including real ID)
        const index = this.variants.findIndex(v => v.id === oldId);
        if (index !== -1) {
          this.variants[index] = { ...response.data.variant };
          if (this.activeVariant === oldId) {
            this.activeVariant = response.data.variant.id;
          }
        }
      } else {
        // Update existing variant
        response = await axios.put(
          `/backend/loyalty-program/point-system-simulations/${this.simulationId}/variants/${variant.id}`,
          payload
        );

        // Update child components with server response
        this.updateChildComponents(variant.id, response.data.variant);
      }

      return response;
    },
    getExclusionProducts(variantId) {
      const ref = this.$refs['exclusionsProduct_' + variantId];
      if (ref && ref[0] && ref[0].getItems) {
        return ref[0].getItems();
      }
      return [];
    },
    getExclusionCustomers(variantId) {
      const ref = this.$refs['exclusionsCustomer_' + variantId];
      if (ref && ref[0] && ref[0].getItems) {
        return ref[0].getItems();
      }
      return [];
    },
    getStatusLevels(variantId) {
      const ref = this.$refs['statusLevels_' + variantId];
      if (ref && ref[0] && ref[0].getItems) {
        return ref[0].getItems();
      }
      return [];
    },
    updateChildComponents(variantId, variantData) {
      const productRef = this.$refs['exclusionsProduct_' + variantId];
      const customerRef = this.$refs['exclusionsCustomer_' + variantId];
      const statusLevelsRef = this.$refs['statusLevels_' + variantId];

      if (productRef && productRef[0] && productRef[0].updateItems && variantData.exclusion_products) {
        productRef[0].updateItems(variantData.exclusion_products);
      }
      if (customerRef && customerRef[0] && customerRef[0].updateItems && variantData.exclusion_customers) {
        customerRef[0].updateItems(variantData.exclusion_customers);
      }
      if (statusLevelsRef && statusLevelsRef[0] && statusLevelsRef[0].updateItems && variantData.status_levels) {
        statusLevelsRef[0].updateItems(variantData.status_levels);
      }
    },
    async saveAll() {
      this.saving = true;
      try {
        // Save simulation data
        await this.saveSimulation();

        // Save all variants with all related data in one request per variant
        for (const variant of this.variants) {
          try {
            await this.saveVariant(variant);
          } catch (error) {
            this.handleVariantError(error, variant.variant_number);
            return;
          }
        }
        this.$refs.toast.s("Simulation erfolgreich gespeichert!", "Erfolg");
      } catch (error) {
        if (error.response && error.response.status === 422 && error.response.data.errors) {
          const errors = error.response.data.errors;
          const errorMessages = Object.values(errors).flat().join('\n');
          this.$refs.toast.e(errorMessages, "Fehler");
        } else if (error.response && error.response.data.message) {
          this.$refs.toast.e(error.response.data.message, "Fehler");
        } else {
          this.$refs.toast.e("Fehler beim Speichern der Simulation.", "Fehler");
        }
      } finally {
        this.saving = false;
      }
    },
    async saveSimulation() {
      const nameInput = document.querySelector('input[name="name"]');
      const clientInput = document.querySelector('select[name="client_id"]') || document.querySelector('input[name="client_id"]');

      const data = {
        name: nameInput ? nameInput.value : '',
        client_id: clientInput ? clientInput.value : this.clientId,
      };

      return axios.put(`/backend/loyalty-program/point-system-simulations/${this.simulationId}`, data);
    },
    async startCalculation() {
      this.saving = true;
      try {
        // First save simulation
        await this.saveSimulation();

        // Then save all variants with all related data
        for (const variant of this.variants) {
          try {
            await this.saveVariant(variant);
          } catch (error) {
            this.handleVariantError(error, variant.variant_number);
            return;
          }
        }
        // Then start calculation
        await axios.post(`/backend/loyalty-program/point-system-simulations/${this.simulationId}/start-calculation`);
        // Redirect to index
        window.location.href = '/backend/loyalty-program/point-system-simulations';
      } catch (error) {
        if (error.response && error.response.status === 422 && error.response.data.errors) {
          const errors = error.response.data.errors;
          const errorMessages = Object.values(errors).flat().join('\n');
          this.$refs.toast.e(errorMessages, "Fehler");
        } else if (error.response && error.response.data.message) {
          this.$refs.toast.e(error.response.data.message, "Fehler");
        } else {
          this.$refs.toast.e("Fehler beim Starten der Berechnung.", "Fehler");
        }
      } finally {
        this.saving = false;
      }
    },
    handleVariantError(error, variantNumber) {
      const prefix = `Variante ${variantNumber}: `;
      if (error.response && error.response.status === 422 && error.response.data.errors) {
        const errors = error.response.data.errors;
        const errorMessages = Object.values(errors).flat().join('\n');
        this.$refs.toast.e(prefix + errorMessages, "Fehler");
      } else if (error.response && error.response.data.message) {
        this.$refs.toast.e(prefix + error.response.data.message, "Fehler");
      } else {
        this.$refs.toast.e(prefix + "Fehler beim Speichern.", "Fehler");
      }
    },
    async copyExclusionsFromPreviousVariant(variant) {
      if (!confirm(`Möchten Sie die Ausschlüsse von Variante ${variant.variant_number - 1} übernehmen? Bestehende Ausschlüsse werden überschrieben.`)) {
        return;
      }

      const previousVariant = this.variants.find(v => v.variant_number === variant.variant_number - 1);
      if (!previousVariant) {
        this.$refs.toast.e("Vorherige Variante nicht gefunden.", "Fehler");
        return;
      }

      const productRef = this.$refs['exclusionsProduct_' + variant.id];
      const customerRef = this.$refs['exclusionsCustomer_' + variant.id];
      const prevProductRef = this.$refs['exclusionsProduct_' + previousVariant.id];
      const prevCustomerRef = this.$refs['exclusionsCustomer_' + previousVariant.id];

      // Copy exclusions locally (without IDs, so they'll be created as new)
      if (productRef && productRef[0] && prevProductRef && prevProductRef[0]) {
        const prevItems = prevProductRef[0].getItems().map(item => ({ id: null, product_group: item.product_group }));
        productRef[0].updateItems(prevItems);
      }
      if (customerRef && customerRef[0] && prevCustomerRef && prevCustomerRef[0]) {
        const prevItems = prevCustomerRef[0].getItems().map(item => ({ id: null, from_number: item.from_number, to_number: item.to_number }));
        customerRef[0].updateItems(prevItems);
      }

      this.$refs.toast.s("Ausschlüsse übernommen!", "Erfolg");
    },
    async deleteVariant(variant) {
      if (!confirm(`Möchten Sie Variante ${variant.variant_number} wirklich löschen?`)) {
        return;
      }

      // If variant is new (not saved to DB yet), just remove it locally
      if (variant._isNew) {
        const index = this.variants.findIndex(v => v.id === variant.id);
        this.variants.splice(index, 1);

        // Renumber variants locally
        this.variants.forEach((v, i) => {
          v.variant_number = i + 1;
        });

        if (this.variants.length > 0) {
          this.activeVariant = this.variants[0].id;
        }

        this.$refs.toast.s("Variante entfernt!", "Erfolg");
        return;
      }

      this.saving = true;
      try {
        await axios.delete(`/backend/loyalty-program/point-system-simulations/${this.simulationId}/variants/${variant.id}`);
        const index = this.variants.findIndex(v => v.id === variant.id);
        this.variants.splice(index, 1);

        // Renumber variants locally
        this.variants.forEach((v, i) => {
          v.variant_number = i + 1;
        });

        if (this.variants.length > 0) {
          this.activeVariant = this.variants[0].id;
        } else {
          this.activeVariant = null;
        }

        this.$refs.toast.s("Variante erfolgreich gelöscht!", "Erfolg");
      } catch (error) {
        if (error.response && error.response.data.message) {
          this.$refs.toast.e(error.response.data.message, "Fehler");
        } else {
          this.$refs.toast.e("Fehler beim Löschen der Variante.", "Fehler");
        }
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style scoped>
.nav-tabs > li > a {
  cursor: pointer;
}

.tab-content {
  border: 1px solid #ddd;
  border-top: none;
}

.mt-4 {
  margin-top: 20px;
}

.mt-3 {
  margin-top: 15px;
}

.mb-3 {
  margin-bottom: 15px;
}

.p-3 {
  padding: 15px;
}

.p-4 {
  padding: 20px;
}
</style>
